// extracted by mini-css-extract-plugin
export default {"social-share-buttons":"yVHJi","socialShareButtons":"yVHJi","social-share-group":"_2_CUA","socialShareGroup":"_2_CUA","social-share-button":"_1okPg","socialShareButton":"_1okPg"};